<template>
  <div class="download-app-warp">
    <div class="download-app-title">DOWNLOAD APP NOW</div>
    <div class="download-app-btns">
      <div class="download-app-btn" @click="onDownload('ios')">
        <img class="download-app-icon" src="@/assets/imgs/apple.png" alt="">
        <div>
          <div class="download-app-tips">Download on the</div>
          <div class="download-app-label">App Store</div>
        </div>
      </div>
      <div class="download-app-btn" @click="onDownload('google')">
        <img class="download-app-icon" src="@/assets/imgs/google.png" alt="">
        <div>
          <div class="download-app-tips">GET IT ON</div>
          <div class="download-app-label">Google Play</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onDownload(type) {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY
      if (type === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl)
      } else {
        this.$toast(this.$t("msg").appoffline)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.download-app-warp {
  background: linear-gradient(177deg, #000000 0%, #545454 100%);
  border-radius: 20px;
  padding: 28px 32px 40px;
  .title {
    font-size: 40px;
    padding-bottom: 24px;
    color: #fff;
  }
  .download-app-btns {
    display: flex;
    .download-app-btn {
      flex: 1;
      height: 82px;
      border: 1Px solid #A5A5A5;
      border-radius: 10px;
      display: flex;
      align-items: center;
      .download-app-icon {
        width: 58px;
        height: 58px;
        display: block;
        margin-left: 12px;
        margin-right: 8px;
      }
      .download-app-tips {
        color: #fff;
        font-size: 20px;
      }
      .download-app-label {
        color: #fff;
        font-size: 32px;
      }
    }
    .download-app-btn + .download-app-btn {
      margin-left: 30px;
    }
  }
}
</style>
